import { padding } from 'csx'
import { extendFrom } from 'vue-tsx-support'

import ConfirmModal from '@/components/ConfirmModal'
import Sidebar from '@/components/semantic-ui/Sidebar'

import { List, defaultList } from '@/datastore/models/list'

import grocery from '@/store/modules/grocery'

import ListSidebarItem from './components/ListSidebarItem'
import SidebarItem from './components/SidebarItem'
import CreateListModal from './modals/CreateListModal'

export default extendFrom(Sidebar).create({
	name: 'Sidebar',
	data() {
		return {
			isCreateListModalVisible: false,
			listToDelete: defaultList,
			newListName: '',
		}
	},
	computed: {
		couponCount(): number {
			return grocery.coupons.length
		},
		isDeleteListModalVisible(): boolean {
			return this.listToDelete !== defaultList
		},
		shoppingListCount(): number {
			return grocery.shoppingListItems.length
		},
	},
	methods: {
		cancelDeleteList(): void {
			this.listToDelete = defaultList
		},
		confirmDeleteList(list: List): void {
			this.listToDelete = list
		},
		createList(): void {
			this.isCreateListModalVisible = false
			grocery.addList(this.newListName)
			this.newListName = ''
		},
		deleteList(): void {
			const route = this.$route
			const listId = this.listToDelete.$id

			if (route.name === 'pantry' && route.params.id === listId) {
				this.$router.push({ name: 'pantry', params: { id: 'all' } })
			}

			grocery.deleteList(listId)

			this.listToDelete = defaultList
		},
		hideCreateListModal(): void {
			this.isCreateListModalVisible = false
		},
		showCreateListModal(): void {
			this.isCreateListModalVisible = true
		},
	},
	watch: {
		$route() {
			this.hide()
		},
	},
	render() {
		const indent = { paddingLeft: padding(40) }
		return (
			<div class="ui left inverted vertical menu sidebar">
				<SidebarItem icon="food" to="/pantry/all?page=0">
					All Items
				</SidebarItem>
				{grocery.lists.map(list =>
					<ListSidebarItem list={list} onDelete={this.confirmDeleteList} style={indent} />)
				}
				<div class="link item" style={indent} onClick={this.showCreateListModal}>
					<i class="add icon" />
					Create List
				</div>
				<SidebarItem badge={this.shoppingListCount} icon="tasks" to="/shopping">
					Shopping List
				</SidebarItem>
				<SidebarItem badge={this.couponCount} icon="money check alternate" to="/coupons">
					Coupons
				</SidebarItem>
				<SidebarItem icon="tags" to="/brands">
					Brands
				</SidebarItem>
				<SidebarItem icon="cloud download" to="/export">
					Export
				</SidebarItem>
				<SidebarItem icon="user" to="/account">
					Account
				</SidebarItem>
				<ConfirmModal
					confirmClass="negative"
					confirmText={`Yes, Delete ${this.listToDelete.name}`}
					header="Delete List?"
					onConfirm={this.deleteList}
					onDecline={this.cancelDeleteList}
					open={this.isDeleteListModalVisible}
					>
					Are you sure you want to delete the <b>{this.listToDelete.name}</b> list?
				</ConfirmModal>
				<CreateListModal
					onConfirm={this.createList}
					onDecline={this.hideCreateListModal}
					open={this.isCreateListModalVisible}
					v-model={this.newListName}
					/>
			</div>
		)
	},
})
